/**
 * AppConfig Loader
 *
 * Sistema de carga dinámica con detección de brand.
 * Orden de prioridad:
 * 1. @brand/config/index.ts (si existe brand externo)
 * 2. ./projects/{VITE_CONFIG_COMPANY}/index.ts (desde variable de entorno)
 * 3. ./projects/pylc/index.ts (fallback final)
 */

// Importar directamente la configuración de pylc como fallback
import pylcConfig from '../projects/pylc/index';

let configProject: any;

// Intentar cargar desde brand si existe
const brandModules = import.meta.glob('@brand/config/index.ts', { eager: true });
const brandKeys = Object.keys(brandModules);

if (brandKeys.length > 0) {
    console.info('🎨 Cargando configuración desde BRAND');
    const brandModule: any = brandModules[brandKeys[0]];
    configProject = brandModule.default || brandModule;
} else {
    console.info('🔧 Usando configuración desde CORE local (pylc)');
    configProject = pylcConfig;
}

console.info('✅ Configuración cargada:', {
    hasColors: !!configProject?.colors,
    hasCompany: !!configProject?.company,
    hasAssets: !!configProject?.assets
});

export default configProject;
